import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MicrosoftOfficeProfileProviderDatasourceService } from '@i2a/web-api-client';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OneDriveReportProfileAlertDelegateModel } from '@i2a/web-api-client';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { BaseOneDriveDelegateComponent } from '../base-one-drive-delegate/base-one-drive-delegate.component';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'i2a-one-drive-instant-messaging',
  templateUrl: '../base-one-drive-delegate/base-one-drive-delegate.component.html',
  styleUrls: ['../base-one-drive-delegate/base-one-drive-delegate.component.scss']
})
export class OneDriveInstantMessagingComponent  extends BaseOneDriveDelegateComponent implements OnInit, OnDestroy {
  
  constructor(
    modalService: NgbModal,
    private microsoftDatasource: MicrosoftOfficeProfileProviderDatasourceService,
    toastr: ToastrService,
    @Inject(I18NEXT_SERVICE) i18Next: ITranslationService) {
    super(modalService, toastr, i18Next);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected AlertOneDriveDelegate(model: OneDriveReportProfileAlertDelegateModel):Observable<any> {
    return this.microsoftDatasource.alertOneDriveDelegateShareInstantMessaging(this.profile.providerInstanceId, this.profile.userId, model);
  }
  
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

}
